import React from "react";
import { View, Text, Pressable, StyleSheet } from "react-native";
import type { BillingType } from "../../models/charger-model";

interface BillingTypeToggleProps {
  value: BillingType;
  onChange: (type: BillingType) => void;
}

const BillingTypeToggle: React.FC<BillingTypeToggleProps> = ({ value, onChange }) => {
  return (
    <View style={styles.wrapper}>
      <Text style={styles.label}>Billing Mode</Text>
      <View style={styles.track}>
        <Pressable
          style={[styles.option, value === "kwh" && styles.optionActive]}
          onPress={() => onChange("kwh")}
        >
          <Text style={[styles.optionText, value === "kwh" && styles.optionTextActive]}>
            Per kWh
          </Text>
        </Pressable>
        <Pressable
          style={[styles.option, value === "hourly" && styles.optionActive]}
          onPress={() => onChange("hourly")}
        >
          <Text style={[styles.optionText, value === "hourly" && styles.optionTextActive]}>
            Per Hour (Parking)
          </Text>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: { marginBottom: 16 },
  label: { color: "#fff", marginBottom: 8, fontWeight: "600", fontSize: 15 },
  track: {
    flexDirection: "row",
    backgroundColor: "#1A1D21",
    borderRadius: 30,
    padding: 3,
  },
  option: {
    flex: 1,
    paddingVertical: 10,
    borderRadius: 28,
    alignItems: "center",
  },
  optionActive: {
    backgroundColor: "#39BEB7",
  },
  optionText: {
    color: "#8D8E90",
    fontWeight: "600",
    fontSize: 14,
  },
  optionTextActive: {
    color: "#fff",
  },
});

export default BillingTypeToggle;
